import React from 'react';
import { Link } from 'react-router-dom';

// Final Logo - Crystal droplet with DNA helix and "PenLab Peptide" text (white background)
const LOGO_URL = "https://customer-assets.emergentagent.com/job_pendesign/artifacts/6jnk614b_ChatGPT%20Image%20Feb%207%2C%202026%20at%2012_05_44%20PM.png";

// Footer Logo - White text version for dark backgrounds
const LOGO_FOOTER_URL = "https://customer-assets.emergentagent.com/job_pendesign/artifacts/fdxs5n32_ChatGPT%20Image%20Feb%207%2C%202026%20at%2012_44_17%20PM.png";

const Logo = ({ variant = 'default', className = '', showText = true, size = 'md' }) => {
  const sizeClasses = {
    sm: 'h-14 md:h-16',
    md: 'h-16 md:h-20 lg:h-24',
    lg: 'h-20 md:h-24 lg:h-28',
    xl: 'h-24 md:h-28 lg:h-32'
  };

  // Default: full logo with image
  return (
    <Link to="/" className={`flex items-center ${className}`}>
      <img 
        src={LOGO_URL} 
        alt="PenLab Peptide" 
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </Link>
  );
};

// Header Logo - Full logo for header (always same size)
export const HeaderLogo = ({ className = '' }) => {
  return (
    <Link to="/" className={`flex items-center justify-center ${className}`} data-testid="header-logo">
      <div className="bg-white">
        <img 
          src={LOGO_URL} 
          alt="PenLab Peptide" 
          className="h-16 sm:h-20 md:h-28 lg:h-32 w-auto object-contain"
          style={{ backgroundColor: '#ffffff' }}
        />
      </div>
    </Link>
  );
};

// Footer Logo - For dark backgrounds (white text version)
export const FooterLogo = ({ className = '' }) => {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`}>
      <img 
        src={LOGO_FOOTER_URL} 
        alt="PenLab Peptide" 
        className="h-16 sm:h-20 md:h-24 w-auto object-contain"
      />
    </Link>
  );
};

// Export the logo URL for use in other components (emails, etc.)
export const PENLAB_LOGO_URL = LOGO_URL;

export default Logo;
